import { createFileRoute } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Benefits } from "@/components/site/Benefits";
import { Services } from "@/components/site/Services";
import { QuotationForm } from "@/components/site/QuotationForm";
import { Gallery } from "@/components/site/Gallery";
import { Solutions } from "@/components/site/Solutions";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Green Volt LTD — Solar PV Installation in Mauritius" },
      {
        name: "description",
        content:
          "Premium solar PV, batteries, inverters and electrical installation in Mauritius. Request a tailored quotation from Green Volt LTD.",
      },
      { property: "og:title", content: "Green Volt LTD — Solar PV in Mauritius" },
      {
        property: "og:description",
        content:
          "Design, installation and maintenance of solar PV systems across Mauritius. Get a smart quotation in minutes.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "/" },
    ],
    links: [{ rel: "canonical", href: "/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "Green Volt LTD",
          description:
            "Solar PV installation, batteries, inverters and electrical works in Mauritius.",
          telephone: "+23057065110",
          email: "sales.greenvolt@gmail.com",
          areaServed: "Mauritius",
          identifier: "C24205569",
        }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <Benefits />
        <Services />
        <QuotationForm />
        <Gallery />
        <Solutions />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster richColors position="top-center" />
    </div>
  );
}
